import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Flex from '../../../Flex';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { BiDataHook } from '../../../biLogger';
import EyeIcon from '../../../Icons/Eye';
import UnwatchIcon from '../../../Icons/Unwatch';
import ErrorIcon from '../../../Icons/Error';
import CommentBox from '../../../CommentBox';
import CommentFooter from '../CommentFooter';
import { withCommentContext, } from '../CommentContext/CommentContext';
import ActionsMenu from '../ActionsMenu';
import { isActionable } from '../../utils';
import s from './CommentContent.scss';
var CommentContent = /** @class */ (function (_super) {
    __extends(CommentContent, _super);
    function CommentContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.cancelHighlight = function () {
            _this.setState({ isHighlighted: false });
        };
        _this.onReveal = function () {
            _this.props.setPeeking(true);
        };
        _this.onCloseEditor = function () {
            var setEditingState = _this.props.setEditingState;
            setEditingState('none');
        };
        _this.hideActionMenu = function () {
            var setActionMenuOpen = _this.props.setActionMenuOpen;
            setActionMenuOpen(false);
        };
        _this.onEditDone = function (result) {
            var _a = _this.props, setEditingState = _a.setEditingState, onCommentUpdated = _a.onCommentUpdated;
            setEditingState('none');
            onCommentUpdated && result.comment && onCommentUpdated(result);
        };
        _this.state = { isHighlighted: props.highlightOnMount };
        return _this;
    }
    CommentContent.prototype.componentDidMount = function () {
        if (this.props.highlightOnMount) {
            window.setTimeout(this.cancelHighlight, 600);
        }
    };
    CommentContent.prototype.render = function () {
        var _a = this.props, comment = _a.comment, isEditing = _a.isEditing;
        if (isEditing) {
            return this.renderEditor(comment);
        }
        return this.renderBody();
    };
    CommentContent.prototype.renderEditor = function (comment) {
        var _a = this.props, currentUser = _a.currentUser, className = _a.className, canPostComment = _a.canPostComment, compact = _a.compact;
        var isChild = !!comment.parentId;
        return (React.createElement(CommentBox, { className: className, onPublishSuccess: this.onEditDone, id: "edit-" + comment.commentId, commentableType: comment.typeId, commentableItemId: comment.itemId, user: currentUser, editComment: comment, autoFocus: true, onClose: this.onCloseEditor, canPostComment: canPostComment, compact: compact || isChild }));
    };
    CommentContent.prototype.renderBody = function () {
        var _a = this.props, comment = _a.comment, isPeeking = _a.isPeeking, onReplyPosted = _a.onReplyPosted, canPostComment = _a.canPostComment, className = _a.className, replyClassName = _a.replyClassName, actionItemClassName = _a.actionItemClassName;
        var isSpam = comment.isSpam, isHidden = comment.isHidden, isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden, isFeatured = comment.isFeatured, replies = comment.replies, user = comment.user;
        var isVisible = !isAdminHidden && !isDeleted;
        if (!isPeeking && isSpam && replies !== 0) {
            return this.renderSpam();
        }
        if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
            return React.createElement("div", null, this.renderHidden());
        }
        if ((isHidden || !isVisible || isSpam) && !isPeeking) {
            return null;
        }
        return (React.createElement(Flex, { className: className },
            user && (React.createElement(UserAvatar, { user: user, size: 32, className: s['avatar'], withTooltip: false })),
            React.createElement("div", { className: s['main-block'] },
                React.createElement("div", { className: classnames(s['body-block'], isFeatured && s['body-block-featured'], isActionable(comment) && s['is-actionable'], this.state.isHighlighted && s['highlight']), onMouseLeave: this.hideActionMenu },
                    React.createElement(Flex, { alignItems: "baseline", className: s['author-block'] },
                        user && (React.createElement(UserLink, { user: user, className: s['userlink'], withTooltip: true, relatedItemBiData: {
                                typeid: comment.typeId,
                                itemid: comment.itemId,
                            } })),
                        this.renderAuthorInfo(),
                        this.renderFeatured()),
                    this.renderCommentViewer(),
                    React.createElement(ActionsMenu, { className: s['actions-menu'], itemClassName: actionItemClassName })),
                React.createElement(CommentFooter, { onReplyPosted: onReplyPosted, canPostComment: canPostComment, replyClassName: replyClassName }))));
    };
    CommentContent.prototype.renderSpam = function () {
        var t = this.props.t;
        return (React.createElement("button", { className: classnames(s['hidden'], s['spam']), onClick: this.canPeek() ? this.onReveal : undefined },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(ErrorIcon, { className: s['hidden-icon'], disableDefaultColors: true }),
                t('comment.visibility.spam'))));
    };
    CommentContent.prototype.renderHidden = function () {
        var t = this.props.t;
        if (this.canPeek()) {
            return (React.createElement("button", { className: classnames(s['hidden'], s['hidden-peekable']), onClick: this.onReveal },
                React.createElement("span", { className: s['hidden-text'] },
                    React.createElement(UnwatchIcon, { className: s['hidden-icon'], disableDefaultColors: true }),
                    t('comment.visibility.hidden')),
                React.createElement("span", { className: classnames(s['hidden-text'], s['hidden-text-peek']) },
                    React.createElement(EyeIcon, { className: s['hidden-icon'], disableDefaultColors: true }),
                    t('comment.visibility.hidden.showComment'))));
        }
        return (React.createElement("button", { className: s['hidden'] },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'], disableDefaultColors: true }),
                t('comment.visibility.hidden'))));
    };
    CommentContent.prototype.renderAuthorInfo = function () {
        var _a = this.props, t = _a.t, _b = _a.comment, user = _b.user, authorInfo = _b.authorInfo;
        var info = (user === null || user === void 0 ? void 0 : user.isNewDeviant) ? t('comment.info.newDeviant') : authorInfo;
        if (!info) {
            return null;
        }
        return React.createElement("span", { className: s['author-info'] }, info);
    };
    CommentContent.prototype.renderFeatured = function () {
        var _a = this.props, isFeatured = _a.comment.isFeatured, t = _a.t;
        if (!isFeatured) {
            return null;
        }
        return (React.createElement("span", { className: s['featured'] }, t('comment.visibility.featuredV2')));
    };
    CommentContent.prototype.renderCommentViewer = function () {
        var _a = this.props.comment, textContent = _a.textContent, commentId = _a.commentId;
        if (!textContent) {
            return null;
        }
        return (React.createElement("div", { "data-hook": BiDataHook.COMMENT_BODY },
            React.createElement(TextRenderer, { className: s['renderer'], textContent: textContent, reactViewer: CommentViewer, legacyTheme: 'comments', viewerKey: commentId })));
    };
    CommentContent.prototype.canPeek = function () {
        // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
        //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
        //         || ($is_author && $is_deleted); // author can see deleted
        var comment = this.props.comment;
        if (comment.isAdminMode) {
            return true;
        }
        if (comment.isOwner) {
            // owner can see owner-hidden
            if (comment.isHidden && !comment.isAdminHidden) {
                return true;
            }
            // and spam
            if (comment.isSpam) {
                return true;
            }
        }
        if (comment.isAuthor) {
            // comment author can see deleted
            if (comment.isDeleted) {
                return true;
            }
        }
        return false;
    };
    return CommentContent;
}(React.Component));
export default withTranslation()(withCommentContext(CommentContent));
//# sourceMappingURL=CommentContent.js.map